<template>
    <div>
        <TerrenoJuegoComponent 
            :direccion_campo="zona.direccion_campo"
            :tipo_recinto="zona.tipo_recinto"
        />

        <SelectorAsientosComponent
            :loading="loading"
            :filas="filas"
            :print_align="zona.print_align"
            :front="true"
            @butacaSeleccionada="toggleSeleccion(...arguments, true, true)"
        />

        <LeyendaButacasComponent/>
    </div>
</template>

<script>
import TerrenoJuegoComponent from '@/components/common/Asientos/TerrenoJuegoComponent.vue'
import LeyendaButacasComponent from '@/components/common/Asientos/LeyendaButacasComponent.vue'
import SelectorAsientosComponent from '@/components/common/Asientos/SelectorAsientosComponent.vue'

export default {
    props: {
        zona: {
            type: Object,
            required: true
        },
        asientos: {
            required: true,
            type: Array
        },
        asientos_maximos: {
            type: Number,
            default: 5
        },
        disabled: {
            required: true,
            type: Boolean
        },
        pack: {
            required: true,
            type: Object
        },
        sesiones_ids: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            loading: true,
            filas: null
        }
    },
    created() {
        this.getAsientosZona(this.zona.id)
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter
        },
        configuracion() {
            return this.$store.getters.getConfig
        },
    },
    methods: {
        getAsientosZona(id) {
            this.loading = true
            var params = {
                filters: {
                    tid : this.configuracion.hash_teatro
                },
                zona_id: id,
                slug: this.pack.slug,
                sesiones_ids: this.sesiones_ids
            }

            this.$store.dispatch(this.config.getVuexAlias('front.packs.show.zonas.show.asientos'), params).then(res => {
                this.filas = res.data.butacas
                this.loading = false
                this.$emit('cargado');
            })            
        },
        toggleSeleccion: function(fila, asiento) {
            if (! this.disabled) {
                for (var i in this.filas[fila]) {
                    if (this.filas[fila][i].asiento == asiento && this.filas[fila][i].ocupado != 1 && this.filas[fila][i].ocupado != 3) {
                        if (this.filas[fila][i].seleccionado) {
                            this.filas[fila][i].seleccionado = false
                            this.$emit('asientoSeleccionado', fila, asiento);
                        } else {
                            if (this.asientos.length < (this.asientos_maximos ? this.asientos_maximos : 15)) {
                                this.filas[fila][i].seleccionado = true
                                this.$emit('asientoSeleccionado', fila, asiento);
                            } else {
                                this.$toast.error(
                                    this.$t('eventos.error_limite_asientos')
                                )
                            }
                        }
                    }
                }
            }
        }
    },
    components: {
        TerrenoJuegoComponent, LeyendaButacasComponent, SelectorAsientosComponent
    },
}
</script>
